<template>
  <div class="integral-earn">
    <headers :title="title"></headers>
    <div class="title">
      <p>{{point_name}}行为</p>
      <p>奖励周期</p>
      <p>奖励{{point_name}}</p>
    </div>
    <ul class="content">
      <li v-for="(item,index) in list" :key="index">
        <p>{{item.name}}</p>
        <p>{{item.period_type_name}}</p>
        <p>
          <span>{{item.integral}}</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import headers from "@/components/Header.vue";
import { IntegralType } from "@/util/enums.js";
export default {
  name: "IntegralEarn",
  components: {
    headers
  },
  data() {
    return {
      title: {
        name: "积分赚取"
      },
      params: {
        change_type: 1
      },
      list: []
    };
  },
  computed: {
    point_name() {
      if(this.$store.state.config){
        return this.$store.state.config.point_info.point_name
      } else{
        return '';
      };
    }
  },
  watch: {
    point_name(val) {
      document.title = val + "赚取";
    }
  },
  async created() {
    let list = await this.$http.get("/api/app/integral/events");
    list.forEach(item => {
      item.period_type_name =
        item.period_type == 1
          ? "一次"
          : item.period_type == 2
          ? "每天"
          : "不限";
    });
    this.list = list;
    document.title = this.point_name + "赚取";
  }
};
</script>

<style lang="scss" scoped>
.integral-earn {
  .title {
    display: flex;
    line-height: 100px;
    p {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 56, 55, 1);
      flex: 1;
      box-sizing: border-box;
      &:nth-child(1) {
        padding-left: 30px;
      }
      &:nth-child(2) {
        width: 160px;
        text-align: center;
        flex: none;
        padding: 0;
      }
      &:nth-child(3) {
        padding-right: 30px;
        text-align: right;
      }
    }
  }
  .content {
    li {
      height: 110px;
      background: rgba(255, 255, 255, 0.89);
      display: flex;
      line-height: 110px;
      border-top: 2px solid #f5f5f5;
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(54, 56, 55, 1);
        flex: 1;
        box-sizing: border-box;
        &:nth-child(1) {
          padding-left: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            background: url("~@/assets/images/integral/earn-left.png") no-repeat;
            background-size: 100% 100%;
            width: 6px;
            height: 42px;
            top: 50%;
            margin-top: -21px;
            left: 0;
          }
        }
        &:nth-child(2) {
          width: 160px;
          text-align: center;
          flex: none;
          padding: 0;
        }
        &:nth-child(3) {
          clear: both;
          padding-right: 30px;
          color: #d0021b;
          span {
            width: 110px;
            float: right;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
